module.exports = __webpack_public_path__ + "img/logo.0bb9c517.png";